/**
 * Whether a street address carries a house number — one rule for the inline
 * check (houseNumber.ts) and for when an address search may start on its own
 * (addressAutocomplete.ts).
 *
 * A house number is a run of digits, optionally with a letter ("12", "96a",
 * "12 High Street"), that is not followed by a full stop and a word: Slovenian
 * street names carry ordinals — "Ulica 1. maja", "Cesta 24. junija", "Cesta 9.
 * korpusa" — and those are part of the name. A stray full stop after the house
 * number itself ("Stara Vrhnika 9.") still counts. Slovenia also registers houses
 * without a number as "b. š." (brez številke), accepted as one.
 */
export function hasHouseNumber(value: string): boolean {
  return /(^|\D)\d+(?!\d)(?!\s*\.\s*\p{L})/u.test(value) || /(^|[\s,(])b\.?\s*š\.?(?=[\s,)]|$)/iu.test(value);
}
